import { VF } from '../../../models/ParamValidator';
import React from 'react';

/**
 * Default cell renderer for DataGrid
 * 
 * @param {Object} props
 * @param {*} props.value - The value to display in the cell
 * @param {boolean} props.isEditable - Whether the cell is editable (affects cursor style and appearance)
 * @param {number} props.tabIndex - Tab index for keyboard navigation
 * @param {Object} props.style - Optional additional styles
 * @returns {JSX.Element}
 */
export function DefaultCell(_ref) {
  let {
    header,
    value,
    isEditable = false,
    tabIndex,
    style = {}
  } = _ref;
  const trimmedValue = value?.trim ? value.trim().toLowerCase() : value;
  const valueIsCheckboxTick = (trimmedValue?.length || 0) > 0 && trimmedValue !== 'false' && header.cellType === 'checkbox';
  let displayValue = value;

  // Need to convert in case its a string '123'. We use Number() instead of parseFloat, because
  // parseFloat reads any number in text. '123 asd' would become 123, which is incorrect.
  const possiblyNumericValue = Number(value);
  if (header.cellType === 'number' && VF.isNumber(possiblyNumericValue)) {
    displayValue = possiblyNumericValue.toLocaleString('en-GB', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  } else if (header.cellType === 'percentage' && VF.isNumber(possiblyNumericValue)) {
    displayValue = `${possiblyNumericValue.toFixed(header.decimalScale ?? 1)}%`;
  }
  const justifyContent = header.cellType === 'percentage' ? 'center' : header.cellType === 'number' ? 'flex-end' : 'flex-start';
  return /*#__PURE__*/React.createElement("div", {
    className: "DataGridTable-DefaultCell",
    style: {
      padding: '4px 8px',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent,
      cursor: isEditable ? 'pointer' : 'default',
      backgroundColor: isEditable ? 'transparent' : '#f5f5f5',
      color: valueIsCheckboxTick ? 'var(--color-primary)' : 'inherit',
      fontSize: valueIsCheckboxTick ? '24px' : 'inherit',
      ...style
    },
    tabIndex: tabIndex
  }, displayValue);
}